import React, { FC, ReactElement } from "react";
import { TextField } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CreateUpdateEntityFormValues } from "../../EntityEditor";

interface AnnualTurnover {
  control: Control<CreateUpdateEntityFormValues>;
}

const AnnualTurnover: FC<AnnualTurnover> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="annualTurnover"
      render={({
        field: { onBlur, onChange, name, value },
        fieldState: { error },
      }): ReactElement => (
        <TextField
          {...{ onBlur, onChange, name, value }}
          fullWidth
          type="text"
          label={t("entitiesManagement.entityEditor.anualTurnover")}
          helperText={error?.message}
          error={Boolean(error)}
        />
      )}
    />
  );
};

export default AnnualTurnover;
